
import { Vue, Component, Prop } from "vue-property-decorator";
import { User } from "@/generated/graphql";

@Component({
  components: {},
})
export default class SmartMatchTab extends Vue {
  @Prop({ type: Boolean, default: false }) readonly invalid!: boolean;
  @Prop({ type: Object, required: true }) readonly formData!: Record<string, any>;
  @Prop({ type: Boolean, default: false }) readonly isDrafted!: boolean;
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;

  openConfigModal() {
    this.$emit('openConfigModal');
  }

  runSearch() {
    console.log("clicked search button");
    this.$emit('openResultsModal');
  }
}
